import { styled } from '@mui/material/styles'
import { Toolbar } from '@mui/material'

export const PageToolbar = styled(Toolbar)(({ theme }) => ({
  backgroundColor: theme.palette.neutral000,
  borderBottom: '1px solid',
  borderColor: theme.palette.neutral300,
}))
